export type SheetKey = "letter" | "legal" | "legal-landscape" | "tabloid";

export interface SheetLayout {
  sheet: SheetKey;
  columns: number;
  rows: number;
}

export interface SheetOption extends SheetLayout {
  perSheet: number;
  sheetLabel: string;
  sheetWidth: number;
  sheetHeight: number;
}

const SHEETS: Record<SheetKey, { label: string; width: number; height: number }> = {
  letter: { label: "Letter", width: 8.5, height: 11 },
  legal: { label: "Legal", width: 8.5, height: 14 },
  "legal-landscape": { label: "Legal", width: 14, height: 8.5 },
  tabloid: { label: "Tabloid", width: 11, height: 17 },
};

const LAYOUTS: Record<string, SheetLayout[]> = {
  "half-page-menu-quarter": [
    { sheet: "letter", columns: 2, rows: 2 },
    { sheet: "tabloid", columns: 2, rows: 4 },
  ],
  "half-page-menu-third": [{ sheet: "legal-landscape", columns: 3, rows: 1 }],
  "half-page-menu": [
    { sheet: "letter", columns: 2, rows: 1 },
    { sheet: "tabloid", columns: 1, rows: 4 },
  ],
  "half-page-menu-long": [{ sheet: "legal", columns: 2, rows: 1 }],
  "half-page-menu-wide": [
    { sheet: "letter", columns: 1, rows: 2 },
    { sheet: "tabloid", columns: 2, rows: 2 },
  ],
  "half-page-menu-wide-landscape": [
    { sheet: "letter", columns: 1, rows: 2 },
    { sheet: "tabloid", columns: 2, rows: 2 },
  ],
};

export function getSheetOptions(size?: string | null): SheetOption[] {
  if (!size) return [];
  return (LAYOUTS[size] ?? []).map((layout) => {
    const sheet = SHEETS[layout.sheet];
    return {
      ...layout,
      perSheet: layout.columns * layout.rows,
      sheetLabel: sheet.label,
      sheetWidth: sheet.width,
      sheetHeight: sheet.height,
    };
  });
}
